import "./App.css";
// import 'whatwg-fetch'
// import 'es6-promise'
import React, { useState, useEffect, useMemo } from "react";
import { Result } from "antd";
import { RightOutlined } from "@ant-design/icons";
import axios from "axios";
import language from "./language";

function App() {
  console.log("国际版");
  const [states, setStates] = useState({ appName: "", versions: [], lang: "" });
  const [flag, setFlag] = useState(false);
  const [labels, setLabels] = useState({
    privacy_history: "",
    app_history: "",
    app_version: "",
  });
  const getValue = (name) => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let res = window.location.search.substr(1).match(reg);
    return res && res[2];
  };
  const isGlobal = useMemo(() => {
    return window.location.host.indexOf("global") !== -1;
  }, []);
  const getRequesturl = (appName, lang) => {
    // 区分测试环境-正式环境与国际版-国内版
    if (process.env.NODE_ENV === "development") {
      return isGlobal
        ? `https://staging-global.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`
        : `http://staging.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`;
    }
    return isGlobal
      ? `https://global.privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`
      : `https://privacy.mi.com/privacy-platform-open/api/product/versions/${appName}/${lang}`;
  };

  const versionZeroDec = `1. 更新联系方式；
  2. 更新小米及第三方信息收集情况；
  3. 更加清楚阐述我们如何使用非个人信息；
  4. 更新个人信息使用情况，包括详述基于正当权益，推送服务相关个人信息的处理；
  5. 补充信息保留政策细节；
  6. 更加清楚阐述您对您的个人信息享有的权利。`;

  // axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
  // axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';

  useEffect(() => {
    const ref = document.referrer; // 前一条地址
    if (ref) {
      const refLang = new URL(ref).pathname.split("/").pop(); // 取出 id_ID
      const cur = new URL(window.location.href);
      const curLang = cur.searchParams.get("lang");
      if (refLang && refLang !== curLang) {
        // 不一致才换
        cur.searchParams.set("lang", refLang);
        window.location.replace(cur.toString()); // 跳转
        console.log(window.location.href);
        return; // 中断后续渲染
      } else {
        const app_Name = getValue("appName");
        console.log(app_Name);
        const lang = getValue("lang") || "zh_CN"; //获取语言参数
        const { privacy_history, version, history_version, title } =
          language[lang] || language["zh_CN"];
        console.log(privacy_history, version, history_version, title);
        // const app_history =
        //   privacy_history.indexOf("Xiaomi") !== -1
        //     ? privacy_history.replace("Xiaomi", app_Name)
        //     : history_version;
        setLabels(() => ({
          privacy_history,
          app_history: history_version,
          app_version: version,
        }));
        document.title = title;
        const url = getRequesturl(app_Name, lang);
        if (app_Name) {
          axios
            .get(url)
            .then((res) => {
              const update = {
                appName: res.data.product_name,
                versions: res.data.versions,
              };
              setStates((prev) => ({ ...prev, ...update, lang: lang }));
              setFlag(false);
            })
            .catch((err) => {
              setFlag(true);
            });
        } else {
          setFlag(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToVersion = (version) => {
    if (process.env.NODE_ENV === "development") {
      window.location.href = isGlobal
        ? `https://staging-global.privacy.mi.com/${states.appName}/v${version}/${states.lang}`
        : `http://staging.privacy.mi.com/${states.appName}/v${version}/${states.lang}`;
    } else {
      window.location.href = isGlobal
        ? `https://global.privacy.mi.com/${states.appName}/v${version}/${states.lang}`
        : `https://privacy.mi.com/${states.appName}/v${version}/${states.lang}`;
    }
  };
  return (
    <div className="markdown-post-container">
      {flag ? (
        <Result
          status="404"
          title={<span className="black">404 Not Found</span>}
          subTitle={
            !isGlobal ? (
              <span className="black">当前页面或资源不存在</span>
            ) : (
              <></>
            )
          }
          className="result-container"
        />
      ) : (
        <>
          <h1 className="markdown-post-title">
            {states.appName
              ? states.appName === "all"
                ? labels.privacy_history
                : labels.app_history
              : ""}
          </h1>
          <ul style={{ margin: 0 }}>
            {states.versions.length > 0 &&
              states.versions.map((v, index) => {
                return (
                  <li
                    style={{ listStyleType: "none", cursor: "pointer" }}
                    key={index}
                    onClick={() => goToVersion(v.version)}
                  >
                    {v.version ? (
                      <>
                        <h3 className="markdown-post-version">{`${labels.app_version}：v${v.version}`}</h3>
                        <div
                          className="markdown-post-version-container"
                          style={{
                            position: "relative",
                            top:
                              v.versionDec ||
                              (states.appName === "all" && v.version === "0")
                                ? null
                                : "-30px",
                          }}
                        >
                          {states.appName === "all" &&
                          v.version.toString() === "0" ? (
                            <p className="desc">{versionZeroDec}</p>
                          ) : (
                            <p className="desc">{v.versionDec}</p>
                          )}
                          <RightOutlined className="rightArrow" />
                        </div>
                      </>
                    ) : null}
                  </li>
                );
              })}
          </ul>
        </>
      )}
    </div>
  );
}

export default App;
